import picture_beforeafter from "@/components/tools/picture_compare.vue";
import { post_Json_elk_statistic } from "@/jsUtils/nodejsRequest";
export default {
  components: {
    picture_beforeafter
  },
  data() {
    return {
      imagelist: [],
      imagelist_narrow: [{
        img_0: require("@/assets/maindetail/compare/memory_0.png"),
        img_1: require("@/assets/maindetail/compare/memory_1.png")
      }, {
        img_0: require("@/assets/maindetail/compare/Energetic_0.png"),
        img_1: require("@/assets/maindetail/compare/Energetic_1.png")
      }, {
        img_0: require("@/assets/maindetail/compare/Fascinatic_0.png"),
        img_1: require("@/assets/maindetail/compare/Fascinatic_1.png")
      }, {
        img_0: require("@/assets/maindetail/compare/Origin_0.png"),
        img_1: require("@/assets/maindetail/compare/Origin_1.png")
      }],
      imagelist_wide: [{
        img_0: require("@/assets/maindetail/compare/memory_0.png"),
        img_1: require("@/assets/maindetail/compare/memory_1.png")
      }, {
        img_0: require("@/assets/maindetail/compare/Energetic_0.png"),
        img_1: require("@/assets/maindetail/compare/Energetic_1.png")
      }, {
        img_0: require("@/assets/maindetail/compare/Fascinatic_0.png"),
        img_1: require("@/assets/maindetail/compare/Fascinatic_1.png")
      }],
      bannerHeight: 0,
      highlightedIndex: 0,
      timer: null
    };
  },
  mounted() {
    this.startTimer();
  },
  methods: {
    startTimer() {
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.timer = setInterval(() => {
        // 更新滚动位置
        // const imageWidth = this.$refs.imageContainer.firstChild.offsetWidth;
        let imageWidth = 80;
        this.$refs.imageContainer.scrollLeft += imageWidth;

        // 更新高亮的图片
        this.highlightedIndex = (this.highlightedIndex + 1) % this.imagelist_narrow.length;
        if (this.highlightedIndex === 0) {
          this.$refs.imageContainer.scrollLeft = 0;
        }
      }, 3000); // 每隔 3 秒更新一次
    },

    setimagelist() {
      // 根据屏幕宽高比，宽高比大于0.9的为宽屏，否则为窄屏
      if (window.innerWidth / window.innerHeight > 0.9) {
        this.imagelist = this.imagelist_wide;
      } else {
        this.imagelist = this.imagelist_narrow;
      }
    },
    handleClick(image, index) {
      // 在这里处理点击事件，例如弹出一个模态框显示大图等。
      // console.log('Image clicked:', image);

      this.highlightedIndex = index;
      clearInterval(this.timer);
      this.startTimer();
      let imagename = image.img_0.split("_")[0];
      imagename = imagename.split("/").pop();
      this.sendElk_Stat("picture_compare_carousel_click", imagename);
    },
    handleScroll() {
      // 这里可以添加滚动时的逻辑，例如加载更多图片等。
    },
    handlePictureSlideStart() {
      clearInterval(this.timer);
    },
    handlePictureSlideEnd() {
      this.startTimer();
      this.sendElk_Stat("picture_compare_carousel_SlideEnd", null);
    },
    sendElk_Stat(clickname, clickdata) {
      let imagename = this.imagelist_narrow[this.highlightedIndex].img_0.split("_")[0];
      imagename = imagename.split("/").pop();
      if (clickdata != null) {
        imagename = clickdata;
      }
      let data = {
        "event": "page_home_click",
        "data": {
          "home_click_name": clickname,
          "home_click_product_type": imagename,
          "home_click_data": "picture_compare_carousel_sample" + "_" + imagename
        }
      };
      post_Json_elk_statistic(data);
    }
  }
};